import { useState } from 'react';

const FAQ_IMAGE =
  'https://d3h1y9jvvpl9bt.cloudfront.net/assets/images/610009ab-605b-40b3-a303-4e68d624ef31/clean-shot-2026-03-08-at-16-49-38-2-x-1920w.webp';

const FAQS = [
  {
    q: 'What is the address for Vela Bay?',
    a: 'Vela Bay is located along Bayshore Road, District 16, Singapore.',
  },
  {
    q: 'How many units are available at Vela Bay?',
    a: 'Vela Bay has a total of 515 residential units ranging from 1+Study to 5-bedroom configurations. More than 70% of units are sea-facing.',
  },
  {
    q: 'What is the price for Vela Bay?',
    a: 'Estimated guide pricing starts at approximately $2,783 psf++. Please register your interest to receive the latest official price list.',
  },
  {
    q: 'What is the expected TOP date for Vela Bay?',
    a: 'The Temporary Occupation Permit (TOP) date for Vela Bay will be announced closer to launch. Please register to stay updated.',
  },
  {
    q: 'Where can I find the showflat for Vela Bay?',
    a: 'The Vela Bay Sales Gallery is strictly by advance appointment only. Contact us at +65 9365 1286 to book your visit.',
  },
  {
    q: 'Who is the developer of Vela Bay?',
    a: 'Vela Bay is developed by SingHaiyi Group / Haiyi Holdings, a reputable developer with a strong track record in Singapore.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  const toggle = (i: number) => setOpen(open === i ? null : i);

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:gap-10">
          {/* Left: FAQ */}
          <div className="flex-1">
            <h2
              className="text-3xl md:text-4xl font-bold text-[#172C37] mb-6 md:mb-8"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              FAQ
            </h2>

            <div className="divide-y divide-[#172C37]/10 border-t border-[#172C37]/10">
              {FAQS.map((faq, i) => (
                <div key={i} className="py-0">
                  <button
                    onClick={() => toggle(i)}
                    className="w-full flex items-center justify-between py-4 md:py-5 text-left cursor-pointer group"
                  >
                    <span className="text-sm md:text-base font-semibold text-[#172C37] pr-4 group-hover:text-[#172C37]/70 transition-colors">
                      {faq.q}
                    </span>
                    <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center text-[#172C37]">
                      {open === i ? (
                        <i className="ri-subtract-line text-xl" />
                      ) : (
                        <i className="ri-add-line text-xl" />
                      )}
                    </span>
                  </button>
                  {open === i && (
                    <div className="pb-4 md:pb-5 pr-10">
                      <p className="text-sm text-[#172C37]/70 leading-relaxed">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="w-full h-64 md:flex-1 md:min-h-[400px] rounded-2xl overflow-hidden">
            <img
              src={FAQ_IMAGE}
              alt="Vela Bay FAQ Bayshore Condominium"
              className="h-full w-full object-cover object-top rounded-2xl"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
